import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind utilities win over earlier ones.
 *
 * Plain concatenation leaves both `p-2` and `p-4` in the class list and the
 * outcome depends on stylesheet order, not call order — which is why a caller's
 * override silently does nothing.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
